import {CMS_LOGGER_NAMES, Logger, LogLevel} from '../../context/logger/Logger';
import {Logger as InspectLogger} from '@volkswagen-onehub/inspect-fa-service';

export function createIntegratorLoggerRefs(logger: Logger): InspectLogger[] {
    return CMS_LOGGER_NAMES.map(name => {
        const log = logger.getScope(name);
        if (log === undefined) {
            return undefined;
        }

        return {
            name,
            get logLevel() {
                return log.currentLevel;
            },
            set logLevel(level: LogLevel) {
                logger.setUseHttp(false);
                log.currentLevel = level;
            }
        };
    }).filter(l => !!l) as InspectLogger[];
}
